import chalet from './chalet'
import { logInfo, logError } from '~/core/logger'

let currentCallInfo = null

export const callNumber = (callSetup, number) =>
  new Promise((resolve, reject) => {
    logInfo({ __filename, number }, 'Starting meeting call')
    const resource = `/vocall/v2/phones/${callSetup.did}/calls`
    const source = callSetup.number
    chalet.connection
      .externalCall({
        method: 'POST',
        resource,
        body: {
          _callOptions: {
            destination: number && number.replace(/[-.() ]/g, ''),
            source: source ? source.replace(/[-.() ]/g, '') : null,
            autoAnswer: callSetup.autoAnswer,
            playWelcome: callSetup.playWelcome,
            callerIdOption: 'extensionDid',
            subject: callSetup.displayName || callSetup.did
          }
        }
      }, () => false)
      .then(response => {
        currentCallInfo = {
          callId: response.success.callId,
          did: callSetup.did
        }
        // successful add call is handled when CTI 2.0 sends events
        logInfo({ __filename }, 'Meeting call successfull')
        resolve(response)
      })
      .catch(error => {
        logError({ __filename, error }, 'Meeting call failed')
        reject(error)
      })
  })

export const endCurrentCall = () =>
  new Promise(resolve => {
    if (!currentCallInfo) {
      resolve()
      return
    }

    const { did, callId } = currentCallInfo
    const resource = `/vocall/v2/phones/${did}/calls/${callId}`
    currentCallInfo = null
    logInfo({ __filename, did, callId }, 'Ending meeting call')
    chalet.connection
      .externalCall({
        method: 'DELETE',
        resource
      }, () => false)
      .then(() => {
        // successful disconnect is handled when CTI 2.0 sends events
        logInfo({ __filename }, 'End meeting call successfull')
        resolve()
      })
      .catch(error => {
        logError({ __filename, error }, 'End meeting call failed')
        resolve()
      })
  })
